import { EnvironmentType, Theme } from "@/types/types";
import {
  LOCALHOST_BASE_URL,
  DEVELOPMENT_BASE_URL,
  DEVELOPMENT_FOND_BASE_URL,
  STAGING_BASE_URL,
  STAGING_FOND_BASE_URL,
  PRODUCTION_BASE_URL,
  LIVE_BASE_URL,
  IIS_BASE_URL,
  IIS_FOND_BASE_URL,
  LIVE_FOND_BASE_URL,
} from "@/util/constants";

export const changeTheme = (theme: Theme) => {
  const html = document.querySelector("html");
  html?.setAttribute("data-theme", theme);
};

export const getThemeType = (theme: Theme) => {
  return theme === "sand" || theme === "pink" || theme === "mint" || theme === "sky" ? "light" : "dark";
};

export const getAnkiroBaseUrl = () => {
  const environments = {
    LOCALHOST: LOCALHOST_BASE_URL,
    DEVELOPMENT: DEVELOPMENT_BASE_URL,
    DEVELOPMENT_FOND: DEVELOPMENT_FOND_BASE_URL,
    STAGING: STAGING_BASE_URL,
    STAGING_FOND: STAGING_FOND_BASE_URL,
    PRODUCTION: PRODUCTION_BASE_URL,
    LIVE: LIVE_BASE_URL,
    FOND: LIVE_FOND_BASE_URL,
    IISLOCALHOST: IIS_BASE_URL,
    IISFONDLOCALHOST: IIS_FOND_BASE_URL
  };
  //get current page url
  const currentUrl = window.location.href;
  if (currentUrl.startsWith(environments.LOCALHOST)) {
    return `https://cowi.ankiro.dk/Rest/Cowi-vacancies-Stage/Search/?Category=Open%20vacancies`;
  }
  else if (currentUrl.startsWith(environments.IISLOCALHOST)) {
    return `https://cowi.ankiro.dk/Rest/Cowi-vacancies-Stage/Search/?Category=Open%20vacancies`;
  }
  else if (currentUrl.startsWith(environments.DEVELOPMENT)) {
    return `https://cowi.ankiro.dk/Rest/Cowi-vacancies-Stage/Search/?Category=Open%20vacancies`;
  } 
  else if (currentUrl.startsWith(environments.STAGING)) {
    return `https://cowi.ankiro.dk/Rest/Cowi-vacancies-Stage/Search/?Category=Open%20vacancies`;
  }
  else if (currentUrl.startsWith(environments.PRODUCTION)) {
    return `https://cowi.ankiro.dk/Rest/Cowi-vacancies/Search/?Category=Open%20vacancies`;
  }
  else if (currentUrl.startsWith(environments.LIVE)) {
    return `https://cowi.ankiro.dk/Rest/Cowi-vacancies/Search/?Category=Open%20vacancies`;
  }
  else {
    return `https://cowi.ankiro.dk/Rest/Cowi-vacancies/Search/?Category=Open%20vacancies`;
  }
}

export const parseUrl = (url: string) => {
  const environments = {
    LOCALHOST: LOCALHOST_BASE_URL,
    DEVELOPMENT: DEVELOPMENT_BASE_URL,
    DEVELOPMENT_FOND: DEVELOPMENT_FOND_BASE_URL,
    STAGING: STAGING_BASE_URL,
    STAGING_FOND: STAGING_FOND_BASE_URL,
    PRODUCTION: PRODUCTION_BASE_URL,
    LIVE: LIVE_BASE_URL,
    FOND: LIVE_FOND_BASE_URL,
    IISLOCALHOST: IIS_BASE_URL,
    IISFONDLOCALHOST: IIS_FOND_BASE_URL
  };

  // Determine the environment and extract parameters
  let environment = '';
  let params: string[] = [];

  if (url.startsWith(environments.LOCALHOST)) {
    environment = 'LOCALHOST';
    params = url.substring(environments.LOCALHOST.length).split('/');
  } 
  else if (url.startsWith(environments.IISLOCALHOST)) {
    environment = 'IISLOCALHOST';
    params = url.substring(environments.IISLOCALHOST.length).split('/');
  }
  else if (url.startsWith(environments.IISFONDLOCALHOST)) {
    environment = 'IISFONDLOCALHOST';
    params = url.substring(environments.IISFONDLOCALHOST.length).split('/');
  }
  else if (url.startsWith(environments.DEVELOPMENT)) {
    environment = 'DEVELOPMENT';
    params = url.substring(environments.DEVELOPMENT.length).split('/');
  } 
  else if (url.startsWith(environments.DEVELOPMENT_FOND)) {
    environment = 'DEVELOPMENT_FOND';
    params = url.substring(environments.DEVELOPMENT_FOND.length).split('/');
  }
  else if (url.startsWith(environments.STAGING)) {
    environment = 'STAGING';
    params = url.substring(environments.STAGING.length).split('/');
  } 
  else if (url.startsWith(environments.STAGING_FOND)) {
    environment = 'STAGING_FOND';
    params = url.substring(environments.STAGING_FOND.length).split('/');
  }
  else if (url.startsWith(environments.PRODUCTION)) {
    environment = 'PRODUCTION';
    params = url.substring(environments.PRODUCTION.length).split('/');
  }
  else if (url.startsWith(environments.LIVE)) {
    environment = 'LIVE';
    params = url.substring(environments.LIVE.length).split('/');
  }
  else if (url.startsWith(environments.FOND)) {
    environment = 'FOND';
    params = url.substring(environments.FOND.length).split('/');
  }  
  else {
    environment = 'UNKNOWN';
  }
  params = params.filter(param => param);

  return { environment, params };
}

export const getBaseUrl = (environment: EnvironmentType) => {
  const environments = {
    LOCALHOST: LOCALHOST_BASE_URL,
    DEVELOPMENT: DEVELOPMENT_BASE_URL,
    DEVELOPMENT_FOND: DEVELOPMENT_FOND_BASE_URL,
    STAGING: STAGING_BASE_URL,
    STAGING_FOND: STAGING_FOND_BASE_URL,
    PRODUCTION: PRODUCTION_BASE_URL,
    LIVE: LIVE_BASE_URL,
    FOND: LIVE_FOND_BASE_URL,
    IISLOCALHOST: IIS_BASE_URL,
    IISFONDLOCALHOST: IIS_FOND_BASE_URL
  };

  return environments[environment];
}


export function formatDate(dateString: string, month: "short" | "long" = "short") {
  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month,
    year: "numeric",
  };

  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", options);
}
type ShareLink = {
  url: string;
  icon: string;
};

export function getSoMeShareLinks(url: string, icons: {icon: string}[]) : ShareLink[]{
  return icons.map((iconObj) =>{
    const {icon} = iconObj;
    let shareLink: ShareLink;

    switch (icon){
      case "Facebook":
        shareLink = {url:`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&src=sdkpreparse`, icon:"Facebook"};
        break;
      case "Twitter":
        shareLink = {url:`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`, icon:"Xicon"};        
        break;
      case "LinkedIn":
        shareLink = {url:`https://www.linkedin.com/shareArticle?mini=true&url=${url}`, icon:"LinkedIn"};        
        break;
      case "MailTo":
        shareLink = {url:`mailto:?subject=Email%20Subject&body=${url}`, icon:"MailTo"};
        break;
      default:
        shareLink = {url:`mailto:?subject=Email%20Subject&body=${url}`, icon:"MailTo"};
        break;
    }
    return shareLink;
  });  
}

export function getParentFromUrl(url:string){
  let path = url;
  path = path.replace(/\/$/, "");
  let segments = path.split("/");
  segments.pop();
  let newPath = segments.join("/");
  return newPath;
}

export function getQueryParameters(): Record<string, string | string[]> {
  const params: URLSearchParams = new URLSearchParams(window.location.search);
  const queryParameters: Record<string, string | string[]> = {};
  
  // params.forEach((value, key) => {
  //   queryParameters[key] = value;
  // });

  params.forEach((value, key) => {
    if (queryParameters[key]) {
      // If the key already exists, convert it to an array if it's not already one
      if (Array.isArray(queryParameters[key])) {
        (queryParameters[key] as string[]).push(value);
      } else {
        queryParameters[key] = [queryParameters[key] as string, value];
      }
    } else {
      // If the key doesn't exist, simply add it
      queryParameters[key] = value;
    }
  });
  return queryParameters;
}

export function addQueryParamToUrl(paramName: string, paramValue: string): void {
  // Create a URL object based on the current location
  const url = new URL(window.location.href);
  url.searchParams.set(paramName, paramValue);
  // Update the URL without reloading the page
  history.pushState({}, '', url.href);
}

export function addMultipleQueryParamsToUrl(paramName: string, paramValue: string): void {
  // Create a URL object based on the current location
  const url = new URL(window.location.href);

  const existingValues = url.searchParams.getAll(paramName);

  if (!existingValues.includes(paramValue)) {
    // Add the new value for the parameter
    url.searchParams.append(paramName, paramValue);
  }else{
    // Set the query parameter
    url.searchParams.set(paramName, paramValue);
  }

  // Update the URL without reloading the page
  history.pushState({}, '', url.href);
}

export function removeQueryParameters(): void {
  const urlWithoutQueryParams: string = window.location.origin + window.location.pathname;
  window.history.replaceState({}, document.title, urlWithoutQueryParams);
}

export function getQueryParametersFromUrl(url: string): string {
  const queryString = url.split('?')[1] || ''; // Split the URL and get the query string part
  return queryString ? `?${queryString}` : ''; // Return the query string, prepended with '?'
}

export function removeQueryParameterByName(paramName: string){
  const urlObj = new URL(window.location.href);
  urlObj.searchParams.delete(paramName);
  window.history.replaceState({}, document.title, urlObj.toString());  
}


export function removeQueryParameterByNameAndLabel(paramName: string, label: string) {
  // Remove only thie selected label from the query parameter
  const urlObj = new URL(window.location.href);
  const paramValues = urlObj.searchParams.getAll(paramName);
  const updatedValues = paramValues.filter(value => value !== label);
  urlObj.searchParams.delete(paramName);
  updatedValues.forEach(value => urlObj.searchParams.append(paramName, value));
  window.history.replaceState({}, document.title, urlObj.toString());
}

export function StripHtml(html: string) {
    // RegEx to strip table
    const outerTdRegex = /(<table[^>]*>|<\/table>|<tbody[^>]*>|<\/tbody>|<tr[^>]*>|<\/tr>|<td[^>]*>|<\/td>)/gi;
    // RegEx to strip span tags style
    const spanTagRegex = /(<span[^>]*>|<\/span>)/gi;
    // RegEx to strip inline style
    const inlineStyleRegex = / style="[^"]*"/g;
    // RegEx to strip empty <p>
    const emptyParagraphRegex = /<p>(&nbsp;|\s)*<\/p>/gi;
    let strippedHtml = html
    // Remove everything outside the <td> element
    strippedHtml = html.replace(outerTdRegex, '');
    // Remove span tags
    strippedHtml = strippedHtml.replace(spanTagRegex, '');
    // Remove inline styles
    strippedHtml = strippedHtml.replace(inlineStyleRegex, '');
    // Remove empty paragraphs
    strippedHtml = strippedHtml.replace(emptyParagraphRegex, '');

    return strippedHtml;
}


export function getCookie(cookieName: string): string | null {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}